"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAssociationsUpdater = createAssociationsUpdater;
exports.updateServiceAssociations = exports.updatePortalAssociations = void 0;

var _BETPortalObjectAssociationsActions = require("crm_ui/BET/engagementAssociations/actions/BETPortalObjectAssociationsActions");

var _BETServiceObjectAssociationsActions = require("crm_ui/BET/engagementAssociations/actions/BETServiceObjectAssociationsActions");

var _difference = _interopRequireDefault(require("transmute/difference"));

function createAssociationsUpdater(associationsAdder, associationRemover) {
  return function (originalAssociations, newAssociations, engagementId, isEmailReply) {
    if (isEmailReply) {
      associationsAdder(engagementId, newAssociations);
    }

    if (!originalAssociations.equals(newAssociations)) {
      var associationsToAdd = (0, _difference.default)(originalAssociations, newAssociations);
      var associationsToRemove = (0, _difference.default)(newAssociations, originalAssociations);

      if (associationsToAdd.size) {
        associationsAdder(engagementId, associationsToAdd);
      }

      if (associationsToRemove.size) {
        associationsToRemove.map(function (association) {
          return associationRemover(engagementId, association);
        });
      }
    }
  };
}

var updatePortalAssociations = createAssociationsUpdater(_BETPortalObjectAssociationsActions.addAssociations, _BETPortalObjectAssociationsActions.removeAssociation);
exports.updatePortalAssociations = updatePortalAssociations;
var updateServiceAssociations = createAssociationsUpdater(_BETServiceObjectAssociationsActions.addAssociations, _BETServiceObjectAssociationsActions.removeAssociation);
exports.updateServiceAssociations = updateServiceAssociations;